export default "/_next/static/images/31764fcbcba64bc13e80dbaaada3a0d4.png";